import { RouteItem, RouteMulti } from './RouteItem';
import { AccountPageSwitcher } from '../pages/account/AccountPageSwitcher';
import { BusinessPage } from '../pages/business/BusinessPage';
import { ReviewPage } from '../pages/review/ReviewPage';
import { DocumentsPage } from '../pages/documents/DocumentsPage';
import { PizzaTrackerPage } from '../pages/pizzatracker/PizzaTrackerPage';
import { RedirectItem } from './RedirectItem.types';
import { PaymentsPage } from '../pages/payments/PaymentsPage';
import { FinancialPage } from '../pages/financial/FinancialPage';
import { WelcomePage } from '../pages/welcome/WelcomePage';

export const welcomeRoutes: RouteItem[] = [
  {
    path: '/welcome',
    title: 'Welcome',
    component: WelcomePage,
  },
];

export const applicationRoutes: RouteItem[] = [
  {
    path: '/application/account',
    title: 'Account',
    icon: 'fas fa-user-circle',
    component: AccountPageSwitcher,
  },
  {
    path: '/application/business',
    title: 'Business',
    icon: 'fas fa-store',
    component: BusinessPage,
  },
  {
    path: '/application/payments',
    title: 'Payments',
    icon: 'fas fa-money-bill-alt',
    component: PaymentsPage,
  },
  {
    path: '/application/financial',
    title: 'Business Owner/Financial',
    icon: 'fas fa-landmark',
    component: FinancialPage,
  },
  {
    path: '/application/documents',
    title: 'Documents/Statements',
    icon: 'fas fa-file-alt',
    component: DocumentsPage,
  },
  {
    path: '/application/review',
    title: 'Review',
    icon: 'fas fa-eye',
    component: ReviewPage,
  },
];

export const trackerRoutes: RouteMulti[] = [
  {
    paths: [
      '/tracker/signed',
      '/tracker/qualitycheck',
      '/tracker/riskreview',
      '/tracker/approved',
    ],
    names: ['Application Signed', 'Quality Check', 'Risk Review', 'Approved'],
    icons: ['1', '2', '3', '4'],
    component: PizzaTrackerPage,
  },
];

export const routes: (RouteItem | RouteMulti)[] = [
  ...welcomeRoutes,
  ...applicationRoutes,
  ...trackerRoutes,
];

export const redirects: RedirectItem[] = [
  {
    from: '/application/volume', // /payments route used to be /volume
    to: '/application/payments',
  },
  {
    from: '/application/',
    to: '/application/account',
  },
  {
    from: '/tracker',
    to: '/tracker/signed',
  },
  {
    from: '/',
    to: '/welcome',
  },
];
